export const DEFAULT_IMAGE_DURATION = 10000;
export const MEDIAFILE_SELECTION_SKELETON_COUNT = 4;
export const TIME_PATTERN = /^\d{2}:[0-5]\d:[0-5]\d$/;

export const DATA_TEST_IDS = {
  MEDIAFILES_EDITOR_SCROLL: 'video_wave_mediafiles_editor_scroll',
  MEDIAFILE_SELECTION_ROW: 'video_mediafile_selection_row',
  MEDIAFILE_SELECTION_SKELETON: 'video_mediafile_selection_skeleton',
  MEDIAFILE_SELECTION_SCROLL: 'video_mediafile_selection_scroll',
  MEDIAFILE_SELECTION_CHECKBOX: (id: string) => `checkbox_item_bind_${id}`,
  MEDIAFILE_LIBRARY_ROW: (id: string) => `video_mediafile_library_row_${id}`,
  MEDIAFILE_EDITOR_ROW: 'video_mediafile_editor_row',
  EMENU_DRAWER_ITEM_TITLE: 'emenu_drawer_item_title',
  EMENU_DURATION_INPUT: 'emenu_duration_input',
  EMENU_ITEM_TITLE: 'emenu_item_title',
  EMENU_REPEATS_COUNT: 'emenu_repeats_count',
  IMAGE_PLAYER: 'image_player',
  MEDIAFILES_TABS_LEFT_CLICK: 'mediafiles_tabs_left_click',
  MEDIAFILES_TABS_RIGHT_CLICK: 'mediafiles_tabs_right_click',
  VIDEO_STREAM_PREVIEW_OVERLAY: 'video_stream_preview_overlay',
  VIDEO_STREAM_PREVIEW_TRIGGER: 'video_stream_preview_trigger',
} as const;
